import { LogoUrl } from '@/constants';

import styles from './index.less';

interface IProps {
  showDefaultLogo?: boolean;
}

const LayoutLoading = (props: IProps) => {
  const { showDefaultLogo = true } = props;

  return (
    <div className="flex items-center justify-center h-full w-full">
      {showDefaultLogo && (
        <div className={styles.defaultLogoContainer}>
          <img className={styles.logo} src={LogoUrl} />
          <div className="text-primary-black text-sm leading-6 font-[Calistoga-Regular]">
            Second Me
          </div>
        </div>
      )}
      <div className={styles.largeLogoContainer}>
        <img className={styles.logo} src={LogoUrl} style={{ width: '84px', height: '48px' }} />
        <div className="text-primary-black text-sm leading-6 font-[Calistoga-Regular] w-[84px] text-center">
          Second Me
        </div>
      </div>
    </div>
  );
};

export default LayoutLoading;
